import { CardBody, CardFooter, CardTitle } from "reactstrap";
import { RoundedCard } from "../../layout/RoundedCard";
import { currencyFormat } from "../../util";
import { RiskPacketSlider } from "./RiskPacketSlider";

interface RiskPacketParams {
  readonly bestValue: number;
  readonly worstValue: number;
  readonly farmValue: number;
  readonly livestockGroup?: "herd" | "flock";
}

export const RiskPacket = ({
  bestValue,
  worstValue,
  farmValue,
  livestockGroup,
}: RiskPacketParams) => {
  const riskPackValue = currencyFormat.format(bestValue - worstValue);
  const toGain = currencyFormat.format(Math.max(bestValue - farmValue, 0));
  const toLose = currencyFormat.format(Math.max(farmValue - worstValue, 0));

  return (
    <RoundedCard className="masonry-item" id="risk-packet">
      <CardTitle tag="h5">Risk Packet</CardTitle>
      <CardBody className="risk-packet-body px-0 px-sm-3 px-md-4">
        <p className="text-center">
          <span className="h2 highlight-primary">{riskPackValue}</span> at risk!
        </p>
        <p>
          This shows the difference between the <strong>best</strong> and{" "}
          <strong>worst</strong> scenarios for a {livestockGroup} of your size.
        </p>
        <p>
          You could secure{" "}
          <span className="h3 highlight-success">{toGain}</span> through
          improved health planning
          <br />
          while <span className="h3 highlight-danger">{toLose}</span> could be
          lost through poor performance.
        </p>
      </CardBody>
      <CardFooter className="mt-4 text-center">
        <RiskPacketSlider
          bestValue={bestValue}
          farmValue={farmValue}
          worstValue={worstValue}
          livestockGroup={livestockGroup}
        />
      </CardFooter>
    </RoundedCard>
  );
};
